module.exports = __webpack_public_path__ + "static/media/messages-bg.2d4f29bb.png";